// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
html {
    width: 100%;
    margin: 0;
    overflow-x: hidden;
}

body {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}

li {
    list-style: none;
}

a,
img,
span,
input,
video,
button {
    display: block;
}

a {
    color: inherit;
    text-decoration: none;
}

a.decoration-underline {
    text-decoration: underline;
    color: var(--primary);
}

img {
    height: auto;
}

input,
button {
    background: none;
    border: none;
    outline: none;
    font: inherit;
}

input {
    width: 100%;
}

button {
    cursor: pointer;
}

option {
    white-space: pre-wrap;
}

select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    border: none;
    background: transparent;
    outline: none;
    color: var(--on-background);
}

md-filled-button,
md-outlined-button {
    box-shadow: var(--elevation-3);
    border-radius: var(--radius-extra-large);
}

md-outlined-button:hover {
    box-shadow: var(--elevation-2);
}

report-card-component,
search-img-card-component {
    display: contents;
}

.fw-300 {
    font-weight: 300;
}

.f-w-bold {
    font-weight: bold;
}

/*-----------------------------------*\\
  # COLORS
\\*-----------------------------------*/

.common-hover:hover {
    cursor: pointer;
    background-color: var(--primary-container);
    color: var(--on-primary-container);
    border-radius: 20px;
    transition: background-color 0.3s ease; /* Smooth transition for background color */
}

/*-----------------------------------*\\
  # OVERLAY
\\*-----------------------------------*/

.overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: transparent;
    backdrop-filter: blur(0.1px);
    z-index: 1;
}

.hidden-overlay {
    display: none;
}

/*-----------------------------------*\\
  # NOTIFICATIONS
\\*-----------------------------------*/

.notification-list {
    position: fixed;
    top: 10px;
    right: 10px;
    display: none;
    flex-direction: column;
    align-items: flex-end;
    z-index: 1001;
    opacity: 0;
    transition: opacity 0.3s ease-in-out; /* Smooth transition for opacity */
}

.notification-message {
    margin-block-start: 10px;
    padding: 16px;
    max-width: 300px;
    height: auto;
    border-radius: 10px;
    box-shadow: var(--elevation-2);
    display: none;
    opacity: 0;
    position: relative;
}

.success-notification {
    background-color: #4caf50;
    color: white;
}

.warning-notification {
    background-color: #ff9800;
    color: white;
}

.error-notification {
    background-color: #f44336;
    color: white;
}

.info-notification {
    background-color: #2196f3;
    color: white;
}

.notification-list.show,
.notification-message.show {
    display: flex;
    opacity: 1;
}

.close-notification-btn {
    position: absolute;
    top: 5px;
    right: 5px;
    cursor: pointer;
    font-size: large;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    text-align: center;
    vertical-align: middle;

    &:hover {
        background-color: var(--outline-variant);
        transition: background-color 0.3s ease; /* Smooth transition for background color */
        color: var(--outline);
    }
}

/*-----------------------------------*\\
  # RIPPLE
\\*-----------------------------------*/

:has(> .state-layer) {
    position: relative;
    overflow: hidden;
    z-index: 1;
}

.state-layer {
    border-radius: inherit;
    inset: 0;
    opacity: 0;
    transition: var(--motion-duration-short-2) var(--motion-easing-linear);
}

:has(> .state-layer):hover > .state-layer {
    opacity: 0.08;
}

:has(> .state-layer):is(:focus, :focus-visible, :active) > .state-layer {
    opacity: 0.12;
}

.ripple,
.state-layer {
    --state-layer-bg: var(--surface);
    background-color: var(--state-layer-bg);
    position: absolute;
    pointer-events: none;
    z-index: 1;
}

.ripple {
    top: 50%;
    left: 50%;
    translate: -50% -50%;
    transform-origin: center;
    border-radius: var(--radius-circle);
    opacity: 0.12;
    animation: ripple 800ms var(--motion-easing-standard) forwards;
}

.icon-btn > .ripple {
    width: 40px;
    height: 40px;
    animation: icon-button-ripple 200ms var(--motion-easing-standard) forwards;
}

@keyframes ripple {
    0% {
        scale: 0;
    }

    100% {
        scale: 2.5;
    }
}

@keyframes icon-button-ripple {
    0% {
        scale: 0;
    }

    100% {
        scale: 1;
    }
}

/*-----------------------------------*\\
  # SCROLLBAR STYLES
\\*-----------------------------------*/

/* Firefox */
* {
    scrollbar-width: auto;
    scrollbar-color: var(--primary) var(--background);
}

/* Chrome, Edge, and Safari */
*::-webkit-scrollbar {
    width: 16px;
}

*::-webkit-scrollbar-track {
    background: var(--background);
}

*::-webkit-scrollbar-thumb {
    background-color: var(--primary);
    border-radius: 10px;
    border: 3px solid var(--background);
}

/*-----------------------------------*\\
  # GO UP BUTTON
\\*-----------------------------------*/
#goUpButton {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 100;
    background-color: var(--primary);
    color: var(--on-primary);
    border: none;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    cursor: pointer;
    display: flex;
    box-shadow: var(--elevation-2);
}

/*-----------------------------------*\\
  # CUSTOM BUTTON SPINNER
\\*-----------------------------------*/
.spinner {
    width: 16px;
    height: 16px;
    border: 2px solid #ccc;
    border-top: 2px solid #333;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -8px;
    margin-left: -8px;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

/*-----------------------------------*\\
  # ANIMATE BORDER
\\*-----------------------------------*/
.border-container {
    border: 3px solid transparent;
}

.animate-border {
    animation: borderAnimation 5s infinite; /* Animation lasts 6s (3s active + 3s inactive) and repeats infinitely */
}

@keyframes borderAnimation {
    0%,
    50% {
        border-color: transparent; /* Inactive */
    }
    25%,
    75% {
        border-color: var(--primary); /* Active border color */
    }
}

/*-----------------------------------*\\
  # MAIN SPINNER
\\*-----------------------------------*/

[data-main-spinner] {
    position: fixed;
    top: 50%;
    left: 50%;
}

/*-----------------------------------*\\
  # NO SHADOWDOM SUPPORT
\\*-----------------------------------*/

.no-shadowdom-support .seo-fallback {
    display: block !important;
    padding: 20px;
    text-align: center;
    background: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    margin: 20px;
}

.no-shadowdom-support .seo-fallback h1 {
    color: #495057;
    margin-bottom: 15px;
}

.no-shadowdom-support .seo-fallback p {
    color: #6c757d;
    font-size: 16px;
    line-height: 1.5;
}
`, "",{"version":3,"sources":["webpack://./../../assets/css/global.css"],"names":[],"mappings":"AAAA;;IAEI,WAAW;IACX,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;;;;;IAMI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,2BAA2B;AAC/B;;AAEA;;IAEI,8BAA8B;IAC9B,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;sCAEsC;;AAEtC;IACI,eAAe;IACf,0CAA0C;IAC1C,kCAAkC;IAClC,mBAAmB;IACnB,sCAAsC,EAAE,2CAA2C;AACvF;;AAEA;;sCAEsC;;AAEtC;IACI,eAAe;IACf,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,4BAA4B;IAC5B,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;;sCAEsC;;AAEtC;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,aAAa;IACb,UAAU;IACV,oCAAoC,EAAE,kCAAkC;AAC5E;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;;IAEI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;;IAEtB;QACI,wCAAwC;QACxC,sCAAsC,EAAE,2CAA2C;QACnF,qBAAqB;IACzB;AACJ;;AAEA;;sCAEsC;;AAEtC;IACI,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,QAAQ;IACR,UAAU;IACV,sEAAsE;AAC1E;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,gCAAgC;IAChC,uCAAuC;IACvC,kBAAkB;IAClB,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,oBAAoB;IACpB,wBAAwB;IACxB,mCAAmC;IACnC,aAAa;IACb,8DAA8D;AAClE;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0EAA0E;AAC9E;;AAEA;IACI;QACI,QAAQ;IACZ;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,QAAQ;IACZ;;IAEA;QACI,QAAQ;IACZ;AACJ;;AAEA;;sCAEsC;;AAEtC,YAAY;AACZ;IACI,qBAAqB;IACrB,iDAAiD;AACrD;;AAEA,6BAA6B;AAC7B;IACI,WAAW;AACf;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;IACnB,mCAAmC;AACvC;;AAEA;;sCAEsC;AACtC;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,wBAAwB;IACxB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,8BAA8B;AAClC;;AAEA;;sCAEsC;AACtC;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,0BAA0B;IAC1B,kBAAkB;IAClB,kCAAkC;IAClC,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;;sCAEsC;AACtC;IACI,6BAA6B;AACjC;;AAEA;IACI,sCAAsC,EAAE,wEAAwE;AACpH;;AAEA;IACI;;QAEI,yBAAyB,EAAE,aAAa;IAC5C;IACA;;QAEI,4BAA4B,EAAE,wBAAwB;IAC1D;AACJ;;AAEA;;sCAEsC;;AAEtC;IACI,eAAe;IACf,QAAQ;IACR,SAAS;AACb;;AAEA;;sCAEsC;;AAEtC;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB","sourcesContent":["body,\nhtml {\n    width: 100%;\n    margin: 0;\n    overflow-x: hidden;\n}\n\nbody {\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n}\n\nli {\n    list-style: none;\n}\n\na,\nimg,\nspan,\ninput,\nvideo,\nbutton {\n    display: block;\n}\n\na {\n    color: inherit;\n    text-decoration: none;\n}\n\na.decoration-underline {\n    text-decoration: underline;\n    color: var(--primary);\n}\n\nimg {\n    height: auto;\n}\n\ninput,\nbutton {\n    background: none;\n    border: none;\n    outline: none;\n    font: inherit;\n}\n\ninput {\n    width: 100%;\n}\n\nbutton {\n    cursor: pointer;\n}\n\noption {\n    white-space: pre-wrap;\n}\n\nselect {\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    border: none;\n    background: transparent;\n    outline: none;\n    color: var(--on-background);\n}\n\nmd-filled-button,\nmd-outlined-button {\n    box-shadow: var(--elevation-3);\n    border-radius: var(--radius-extra-large);\n}\n\nmd-outlined-button:hover {\n    box-shadow: var(--elevation-2);\n}\n\nreport-card-component,\nsearch-img-card-component {\n    display: contents;\n}\n\n.fw-300 {\n    font-weight: 300;\n}\n\n.f-w-bold {\n    font-weight: bold;\n}\n\n/*-----------------------------------*\\\n  # COLORS\n\\*-----------------------------------*/\n\n.common-hover:hover {\n    cursor: pointer;\n    background-color: var(--primary-container);\n    color: var(--on-primary-container);\n    border-radius: 20px;\n    transition: background-color 0.3s ease; /* Smooth transition for background color */\n}\n\n/*-----------------------------------*\\\n  # OVERLAY\n\\*-----------------------------------*/\n\n.overlay {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    height: 100%;\n    background: transparent;\n    backdrop-filter: blur(0.1px);\n    z-index: 1;\n}\n\n.hidden-overlay {\n    display: none;\n}\n\n/*-----------------------------------*\\\n  # NOTIFICATIONS\n\\*-----------------------------------*/\n\n.notification-list {\n    position: fixed;\n    top: 10px;\n    right: 10px;\n    display: none;\n    flex-direction: column;\n    align-items: flex-end;\n    z-index: 1001;\n    opacity: 0;\n    transition: opacity 0.3s ease-in-out; /* Smooth transition for opacity */\n}\n\n.notification-message {\n    margin-block-start: 10px;\n    padding: 16px;\n    max-width: 300px;\n    height: auto;\n    border-radius: 10px;\n    box-shadow: var(--elevation-2);\n    display: none;\n    opacity: 0;\n    position: relative;\n}\n\n.success-notification {\n    background-color: #4caf50;\n    color: white;\n}\n\n.warning-notification {\n    background-color: #ff9800;\n    color: white;\n}\n\n.error-notification {\n    background-color: #f44336;\n    color: white;\n}\n\n.info-notification {\n    background-color: #2196f3;\n    color: white;\n}\n\n.notification-list.show,\n.notification-message.show {\n    display: flex;\n    opacity: 1;\n}\n\n.close-notification-btn {\n    position: absolute;\n    top: 5px;\n    right: 5px;\n    cursor: pointer;\n    font-size: large;\n    border-radius: 50%;\n    width: 20px;\n    height: 20px;\n    text-align: center;\n    vertical-align: middle;\n\n    &:hover {\n        background-color: var(--outline-variant);\n        transition: background-color 0.3s ease; /* Smooth transition for background color */\n        color: var(--outline);\n    }\n}\n\n/*-----------------------------------*\\\n  # RIPPLE\n\\*-----------------------------------*/\n\n:has(> .state-layer) {\n    position: relative;\n    overflow: hidden;\n    z-index: 1;\n}\n\n.state-layer {\n    border-radius: inherit;\n    inset: 0;\n    opacity: 0;\n    transition: var(--motion-duration-short-2) var(--motion-easing-linear);\n}\n\n:has(> .state-layer):hover > .state-layer {\n    opacity: 0.08;\n}\n\n:has(> .state-layer):is(:focus, :focus-visible, :active) > .state-layer {\n    opacity: 0.12;\n}\n\n.ripple,\n.state-layer {\n    --state-layer-bg: var(--surface);\n    background-color: var(--state-layer-bg);\n    position: absolute;\n    pointer-events: none;\n    z-index: 1;\n}\n\n.ripple {\n    top: 50%;\n    left: 50%;\n    translate: -50% -50%;\n    transform-origin: center;\n    border-radius: var(--radius-circle);\n    opacity: 0.12;\n    animation: ripple 800ms var(--motion-easing-standard) forwards;\n}\n\n.icon-btn > .ripple {\n    width: 40px;\n    height: 40px;\n    animation: icon-button-ripple 200ms var(--motion-easing-standard) forwards;\n}\n\n@keyframes ripple {\n    0% {\n        scale: 0;\n    }\n\n    100% {\n        scale: 2.5;\n    }\n}\n\n@keyframes icon-button-ripple {\n    0% {\n        scale: 0;\n    }\n\n    100% {\n        scale: 1;\n    }\n}\n\n/*-----------------------------------*\\\n  # SCROLLBAR STYLES\n\\*-----------------------------------*/\n\n/* Firefox */\n* {\n    scrollbar-width: auto;\n    scrollbar-color: var(--primary) var(--background);\n}\n\n/* Chrome, Edge, and Safari */\n*::-webkit-scrollbar {\n    width: 16px;\n}\n\n*::-webkit-scrollbar-track {\n    background: var(--background);\n}\n\n*::-webkit-scrollbar-thumb {\n    background-color: var(--primary);\n    border-radius: 10px;\n    border: 3px solid var(--background);\n}\n\n/*-----------------------------------*\\\n  # GO UP BUTTON\n\\*-----------------------------------*/\n#goUpButton {\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    z-index: 100;\n    background-color: var(--primary);\n    color: var(--on-primary);\n    border: none;\n    border-radius: 50%;\n    width: 50px;\n    height: 50px;\n    cursor: pointer;\n    display: flex;\n    box-shadow: var(--elevation-2);\n}\n\n/*-----------------------------------*\\\n  # CUSTOM BUTTON SPINNER\n\\*-----------------------------------*/\n.spinner {\n    width: 16px;\n    height: 16px;\n    border: 2px solid #ccc;\n    border-top: 2px solid #333;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    margin-top: -8px;\n    margin-left: -8px;\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n/*-----------------------------------*\\\n  # ANIMATE BORDER\n\\*-----------------------------------*/\n.border-container {\n    border: 3px solid transparent;\n}\n\n.animate-border {\n    animation: borderAnimation 5s infinite; /* Animation lasts 6s (3s active + 3s inactive) and repeats infinitely */\n}\n\n@keyframes borderAnimation {\n    0%,\n    50% {\n        border-color: transparent; /* Inactive */\n    }\n    25%,\n    75% {\n        border-color: var(--primary); /* Active border color */\n    }\n}\n\n/*-----------------------------------*\\\n  # MAIN SPINNER\n\\*-----------------------------------*/\n\n[data-main-spinner] {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n}\n\n/*-----------------------------------*\\\n  # NO SHADOWDOM SUPPORT\n\\*-----------------------------------*/\n\n.no-shadowdom-support .seo-fallback {\n    display: block !important;\n    padding: 20px;\n    text-align: center;\n    background: #f8f9fa;\n    border: 1px solid #dee2e6;\n    border-radius: 8px;\n    margin: 20px;\n}\n\n.no-shadowdom-support .seo-fallback h1 {\n    color: #495057;\n    margin-bottom: 15px;\n}\n\n.no-shadowdom-support .seo-fallback p {\n    color: #6c757d;\n    font-size: 16px;\n    line-height: 1.5;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
